import { Chevron } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { NAMESPACE } from 'locale'
import { toDosConstants } from 'locale/toDos'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type DayNavigationProps = {
  handlePreviousDay: () => void
  handleNextDay: () => void
}

const DayNavigation = ({
  handlePreviousDay,
  handleNextDay,
}: DayNavigationProps) => {
  const { t } = useTranslation(NAMESPACE.TODOS)
  return (
    <Wrapper>
      <DayButton onClick={handlePreviousDay}>
        <Chevron direction="left" />
        <Text level={1}>{t(toDosConstants.PREVIOUS_DAY)}</Text>
      </DayButton>
      <DayButton onClick={handleNextDay}>
        <Text level={1}>{t(toDosConstants.NEXT_DAY)}</Text>
        <Chevron direction="right" />
      </DayButton>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  margin-top: 12px;
  ${({ theme }) => theme.mediaQueries?.mobileDown} {
    padding: 12px 0;
  }
`

const DayButton = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  color: ${({ theme }) => theme.color.neutral.color4};
  &:hover {
    color: ${({ theme }) => theme.color.status.primary};
    > svg > path {
      stroke: ${({ theme }) => theme.color.status.primary};
    }
  }
`

export default DayNavigation
